export type Address = {
  street: string;
  city: string;
  zipCode: string;
  state: string | null;
  country: string;
};
